import { FileType } from "./enums/filetypoe.type";



export class FileData {
  ID: number;
  NAME: string;
  TYPE: FileType;
  CREATED_DATE: Date;

  // Helper
  SELECTED: boolean = false;

  constructor(values: any = {}){
    Object.assign(this, values);
  }

  static parse(json: any): FileData {
    if (json) {
      const f = new FileData();

      f.ID = json.ID;
      f.NAME = json.NAME;
      f.TYPE = json.TYPE;
      f.CREATED_DATE = json.CREATED_DATE;
      f.SELECTED = false;

      return f;
    } else { return null; }
  }

  static parseArray(json: any[]): FileData[] {
    const arr = [];

    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(FileData.parse(j));
        }
      }
    }

    return arr;
  }
}
